document.addEventListener('DOMContentLoaded', function() {
  const priceElement = document.querySelector('.product-price--original');
  if (priceElement) {
    const priceValue = priceElement.getAttribute('data-price');
    if (priceValue) {
      // Create a new span for the schema price
      const schemaPrice = document.createElement('span');
      schemaPrice.className = 'actual-price money';
      schemaPrice.setAttribute('itemprop', 'price');
      schemaPrice.setAttribute('content', priceValue);
      schemaPrice.style.display = 'none'; // Hide the duplicate price
      
      // Insert the schema price span
      priceElement.appendChild(schemaPrice);
    }
  }
}); 